import { create } from 'zustand';
import { useShallow } from 'zustand/react/shallow';

type DashboardPartnersPopoverStore = {
  anchorEl: HTMLElement | null;
  open: (anchorEl: HTMLElement) => void;
  close: () => void;
};

const useDashboardPartnersPopoverStore = create<DashboardPartnersPopoverStore>(
  (set) => ({
    anchorEl: null,
    open: (anchorEl) => set({ anchorEl }),
    close: () => set({ anchorEl: null }),
  }),
);

export const useDashboardPartnersPopover = () =>
  useDashboardPartnersPopoverStore(
    useShallow(({ anchorEl, open, close }) => ({ anchorEl, open, close })),
  );

export default useDashboardPartnersPopoverStore;
